// extracted by mini-css-extract-plugin
export default {"tag":"statusTag_tag__aMFBT","tag--active":"statusTag_tag--active__ckX5R","tag--pending":"statusTag_tag--pending__X++yi","tag--completed":"statusTag_tag--completed__W65iB"};